import React, { useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  getAttachmentLargeUrl,
  getAttachmentMediumUrl,
} from "../utils/attachmentImages";

const CustomPrevArrow = ({ className, style, onClick }) => {
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(0,0,0,.5)",
        borderRadius: "50%",
        left: "15px",
        zIndex: 1,
        width: "20px",
        height: "20px",
        cursor: "pointer",
        transition: "all 0.3s ease",
      }}
      onClick={onClick}
    ></div>
  );
};

const CustomNextArrow = ({ className, style, onClick }) => {
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(0,0,0,.5)",
        borderRadius: "50%",
        right: "15px",
        zIndex: 1,
        width: "20px",
        height: "20px",
        cursor: "pointer",
        transition: "all 0.3s ease",
      }}
      onClick={onClick}
    ></div>
  );
};

const CarouselDetailView = ({
  attachments,
  loadedFullImageIndices = new Set(),
  activeIndex = 0,
  onSlideChange,
}) => {
  const sliderRef = useRef(null);

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(activeIndex);
    }
  }, [activeIndex]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 200,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    initialSlide: activeIndex,
    beforeChange: (_current, next) => {
      onSlideChange?.(next);
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  if (!Array.isArray(attachments) || attachments.length === 0) {
    return null;
  }

  return (
    <div className="h-full w-full [&_.slick-slider]:h-full [&_.slick-list]:h-full [&_.slick-track]:h-full [&_.slick-slide>div]:h-full">
      <Slider ref={sliderRef} {...settings}>
        {attachments.map((attachment, index) => {
          const loadFull = loadedFullImageIndices.has(index);
          const src = loadFull
            ? getAttachmentLargeUrl(attachment)
            : getAttachmentMediumUrl(attachment);

          return (
            <div key={attachment.id ?? index} className="relative w-full h-full p-2">
              <div className="flex h-full w-full items-center justify-center">
                <img
                  src={src}
                  alt={`Asset ${index + 1}`}
                  className="max-h-full max-w-full rounded-md object-contain"
                />
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default CarouselDetailView;
